import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

function OfferCard({ offer }) {
    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    const [cardWidth, setCardWidth] = useState(0);

    useEffect(() => {
        setCardWidth((zoomSize/100)*158);
    }, [zoomSize]);

    return (
        <div style={{ width: `${cardWidth}px` }} className='h-auto rounded-xl overflow-hidden shrink-0'>
            <img className='w-full h-auto' src={offer?.couponImage} alt={offer.couponName} />
        </div>
    );
}

export default OfferCard;
